<template>
    <v-list
        dense
        rounded
        class="d-flex flex-column align-md-start"
        :style="white ? 'background-color: transparent' : ''"
    >
        <v-list-item
            v-for="({ link, icon, text }, i) in contacts"
            :key="i"
            :href="link"
            target="_blank"
        >
            <v-list-item-icon>
                <v-icon :color="white ? 'white' : ''">{{ icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title :class="white ? 'white--text' : ''">
                    {{ text }}
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</template>

<script>
const CONTACT_TRYOUT = 1
const CONTACT_TUTOR = 2

export default {
    props: {
        white: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            availableContacts: {
                [CONTACT_TRYOUT]: [
                    {
                        link: 'https://wa.me/+6281287180586',
                        icon: 'mdi-whatsapp',
                        text: '+6281-2871-8058-6',
                    },
                    {
                        link: 'https://www.instagram.com/ukomnakes.id/',
                        icon: 'mdi-instagram',
                        text: '@ukomnakes.id',
                    },
                ],

                [CONTACT_TUTOR]: [
                    {
                        link: 'https://instagram.com/mediko.id/',
                        icon: 'mdi-instagram',
                        text: '@mediko.id',
                    },
                    {
                        link: 'https://wa.me/6281259119472',
                        icon: 'mdi-whatsapp',
                        text: '081259119472',
                    },
                    {
                        link: 'http://line.me/ti/p/~@mediko.belajarfk',
                        icon: 'fab fa-line',
                        text: '@mediko.belajarfk',
                    },
                ],
            },
        }
    },

    computed: {
        contacts() {
            return this.availableContacts[
                this.$store.get('enrollment/selected@contact_type') ??
                    CONTACT_TRYOUT
            ]
        },
    },
}
</script>
